import { render, staticRenderFns } from "./SalesEmailConfigsTable.vue?vue&type=template&id=67e3e1cf"
import script from "./SalesEmailConfigsTable.vue?vue&type=script&lang=js"
export * from "./SalesEmailConfigsTable.vue?vue&type=script&lang=js"
import style0 from "./SalesEmailConfigsTable.vue?vue&type=style&index=0&id=67e3e1cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports